export default "__VITE_ASSET__DQG6j$3m__"